import { LineItem } from './types';

export function calcLineItem(item: Partial<LineItem>): LineItem {
  const qty = Number(item.qty) || 0;
  const rate = Number(item.rate) || 0;
  const gstRate = Number(item.gstRate) || 0;
  const amount = qty * rate;
  const gstAmount = (amount * gstRate) / 100;
  return {
    id: item.id ?? '',
    srNo: item.srNo ?? 1,
    description: item.description ?? '',
    hsn: item.hsn ?? '',
    unit: item.unit ?? 'Nos',
    qty,
    rate,
    gstRate,
    amount,
    gstAmount,
    total: amount + gstAmount,
  };
}

export function calcTotals(items: LineItem[]) {
  const subtotal = items.reduce((s, i) => s + i.amount, 0);
  const totalGST = items.reduce((s, i) => s + i.gstAmount, 0);
  const grandTotal = subtotal + totalGST;
  return { subtotal, totalGST, grandTotal };
}

export function formatINR(val: number): string {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(val);
}

export function numberToWords(num: number): string {
  const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
    'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  if (num === 0) return 'Zero';

  function below100(n: number): string {
    if (n < 20) return ones[n];
    return tens[Math.floor(n / 10)] + (n % 10 ? ' ' + ones[n % 10] : '');
  }

  function below1000(n: number): string {
    if (n < 100) return below100(n);
    return ones[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' ' + below100(n % 100) : '');
  }

  const integer = Math.floor(num);
  const decimal = Math.round((num - integer) * 100);

  let result = '';
  let n = integer;

  if (n >= 10000000) {
    result += below1000(Math.floor(n / 10000000)) + ' Crore ';
    n %= 10000000;
  }
  if (n >= 100000) {
    result += below1000(Math.floor(n / 100000)) + ' Lakh ';
    n %= 100000;
  }
  if (n >= 1000) {
    result += below1000(Math.floor(n / 1000)) + ' Thousand ';
    n %= 1000;
  }
  if (n > 0) result += below1000(n);

  result = result.trim() + ' Rupees';
  if (decimal > 0) result += ' and ' + below100(decimal) + ' Paise';
  result += ' Only';

  return result;
}